
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsPromoTypeDialog extends Serenity.EntityDialog<PsPromoTypeRow, any> {
        protected getFormKey() { return PsPromoTypeForm.formKey; }
        protected getIdProperty() { return PsPromoTypeRow.idProperty; }
        protected getLocalTextPrefix() { return PsPromoTypeRow.localTextPrefix; }
        protected getNameProperty() { return PsPromoTypeRow.nameProperty; }
        protected getService() { return PsPromoTypeService.baseUrl; }
        protected getDeletePermission() { return PsPromoTypeRow.deletePermission; }
        protected getInsertPermission() { return PsPromoTypeRow.insertPermission; }
        protected getUpdatePermission() { return PsPromoTypeRow.updatePermission; }

        protected form = new PsPromoTypeForm(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            return buttons;


        }
    }
}